export default __webpack_public_path__ + "static/media/nonAuth.0f0164a8.svg";